import React, { forwardRef } from "react";
import { BiSolidBell } from "react-icons/bi";
import { formatBadgeCount } from "../model/notificationBadge";

export const NotificationBell = forwardRef(function NotificationBell(
  { unreadCount = 0, onClick, label },
  ref,
) {
  const badgeValue = formatBadgeCount(unreadCount);

  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      aria-label={label}
      className="bg-secondaryColor/10 hover:bg-onHoverGreen/20 relative p-1.5 rounded-md w-fit text-textSecondaryColor"
    >
      <BiSolidBell fontSize={18} />
      {badgeValue && (
        <span className="absolute block top-1 right-1.5 bg-secondaryColor text-white text-[8px] font-medium py-.5 px-1 rounded-full">
          {badgeValue}
        </span>
      )}
    </button>
  );
});
